


























import {Prop, Watch} from "vue-property-decorator";
import {Stored} from 'vue-stored-prop-decorator';
import {Component, Vue} from '@/shared/component';
import {Timeout, WatchObjectProperties} from '@/shared/decorator';

import storeLongueursAchat, {LongueursAchatFilter} from '@/stores/modules/longueursAchat';

import TrueFalseMultiSelect from '@/components/Input/TrueFalseMultiSelect.vue';

@Component({
	components: {
		TrueFalseMultiSelect,
	}
})
export default class CrudLongueursAchatFilter extends Vue {
	
	@Prop({ type: Boolean, default: false}) reduce;
	
	@Stored(() => storeLongueursAchat) private page!: number;
	@Stored(() => storeLongueursAchat) private filters!: LongueursAchatFilter;
	
	@WatchObjectProperties('filters', LongueursAchatFilter)
	@Timeout()
	private filtersWatcher(): void {
		this.page = 0;
		storeLongueursAchat.dispatch('getC', { filters: true });
	}
	
}
